<template>
    <v-row>
        <v-col
            v-for="(card, idx) in cards"
            :key="idx"
            :cols="getFlex(idx) ? 4 : 8"
        >
        
            <v-card 
                class="py-4 d-flex align-stretch flex-column" 
                height="100%" 
                :flat="card.title == ''" 
                :class="getFlex(idx) ? `px-3` : `px-6`" 
                :style="card.title == '' ? `background-color: #EFEFEF;` : ``"
            >                
                <!-- <div v-if="card.title" class="cr cr-top cr-right cr-topleft-border sansation font-weight-bold" :class="`cr-${card.service}`">{{ card.service }}</div> -->
                <div v-if="card.title" class="ribbon ribbon-top ribbon-right" :class="`ribbon-${card.service}`">
                    <div class="ribbon-text sansation font-weight-bold">{{ card.service }}</div>
                </div>
                <v-card-title v-if="card.title" class="grey--text text--darken-1 sansation_subtitle">
                    {{ card.title }} <a :href="card.url" target="_blank"><v-icon small color="grey--darken-1" class="ml-3 mt-n1">{{ icons.openInNewIcon }}</v-icon></a>
                </v-card-title>

                <v-card flat tile class="d-flex flex-column px-4 mb-4" height="100%" style="background-color: transparent">                    
                    <v-card flat tile class="mb-auto" style="background-color: transparent">
                        <div v-if="card.title == ''" class="py-12 text-center" style="background-color: #EFEFEF">
                            <v-chip class="my-12 px-12 py-8 sansation_chip text--disabled">{{ card.desc }}</v-chip>
                        </div>
                        <div v-else>
                            <div class="thin_font grey--text text--darken-1">{{ card.desc }}</div>
                        </div>
                    </v-card>
                    
                    <v-card flat tile class="mb-0" style="background-color: transparent">
                        <div v-if="card.modules.length" class="d-flex d-block my-4">
                            <span class="d-inline font-weight-bold grey--text mr-4">Modules</span> <v-divider class="d-inline mt-3"></v-divider>
                        </div>
                        <div v-if="card.modules.length" class="d-flex" :class="card.modules.length==1 ? `justify-center` : `justify-space-around`">
                            <v-card flat tile v-for="mod in card.modules" :key="mod.name" class="d-inline text-center">
                                <div v-if="mod.url">
                                <a :href="mod.url" target="_blank" style="text-decoration: none">
                                    <customIcon :name='mod.icon' :class="`${mod.color}--text`" class="icon-size icon-center d-block" />
                                    <div class="grey--text text--darken-1" v-html="mod.name"></div>
                                </a>
                                </div>
                                <div v-else>
                                    <customIcon :name='mod.icon' :class="`${mod.color}--text`" class="icon-size icon-center d-block" />
                                    <div class="grey--text text--darken-1">{{ mod.name }}</div>
                                </div>
                            </v-card>
                        </div>
                    </v-card>
                </v-card>
            </v-card>
        </v-col>
    </v-row>
</template>


<script>
    import axios from 'axios'
    import appUrls from '../helpers/environment'
    import { mdiOpenInNew, mdiShieldHalfFull } from '@mdi/js'
    import { is_Even } from './utilities';

    export default {
        name: 'ServiceCards',

        data () {
            return {
                icons: {
                    openInNewIcon: mdiOpenInNew,
                    shieldIcon: mdiShieldHalfFull
                },
                cards: [
                    {   title: 'Business Valuation', 
                        desc: 'SRG Valuation service provides advisors with an objective 3rd party opinion of value based on actual comparable sales in the financial services industry leveraging SRG’s proprietary nationwide database of actual deals completed, combined with our expertise and knowledge of the market.', 
                        modules: [{   
                            name: 'Valuation', 
                            icon: 'valuation', 
                            color: 'value', 
                            url: 'https://www.successionresource.com/valuation/'
                        }],
                        url: 'https://www.successionresource.com/value/',
                        service: 'Value'
                    },
                    
                    {   title: 'Talent Development', 
                        desc: 'SRG works directly with you and your team to assist with employment agreements, affiliation agreements, phantom equity plans, or restrictive covenants.', 
                        modules: [{ 
                            name: 'Entity Support', 
                            icon: 'entity-support', 
                            color: 'improve', 
                            url: 'https://www.successionresource.com/entity-support'
                        },{ 
                            name: 'Employee Resource', 
                            icon: 'employment-resources', 
                            color: 'improve',
                            url: 'https://www.successionresource.com/employment-resources'
                        },{ 
                            name: 'Equity Sharing Plans', 
                            icon: 'equity', 
                            color: 'improve', 
                            url: 'https://www.successionresource.com/equity-sharing/' 
                        }],
                        url: 'https://www.successionresource.com/improve/',
                        service: 'Improve'
                    },

                    {   title: 'Death & Disability', 
                        desc: 'Create a plan to ensure your clients are taken care of, preserve the business and value you have worked so hard to build, and protect your beneficiaries in the event sometihng should ever happen to you.', 
                        modules: [{ 
                            name: 'Contingency Plan', 
                            icon: 'contingency', 
                            color: 'protect', 
                            url: 'https://www.successionresource.com/contingency-planning/'
                        }],
                        url: 'https://successionresource-6155808.hs-sites.com/service-overview-protect?hsCtaTracking=168f7e67-75e4-45f5-b381-dc296823115f%7C861e6690-89f6-4e3c-9c3e-1cc472722f8c',
                        service: 'Protect'
                    },

                    {   title: 'Growth & Acquisition Services', 
                        desc: 'We are dedicated to helping advisors get deals done - whether you are pursuing a complete buy-out of a peer/partner/employer, a merger, or a partial book acquisition. SRG has decades of experience helping Registered Investment Advisors, advisors affiliated with an IBD, hybrids and those that are dually registered - we know the industry, we know the players, and we know mergers and acquisitions.', 
                        modules: [{ 
                            name: 'Deal Support', 
                            icon: 'deal-support', 
                            color: 'grow', 
                            url: 'https://www.successionresource.com/deal-support/'
                        },{ 
                            name: 'Merger', 
                            icon: 'merger', 
                            color: 'grow', 
                            url: 'https://www.successionresource.com/advisor-merger-support/'
                        },{ 
                            name: 'AquireEdge (ACE)', 
                            icon: 'ace', 
                            color: 'grow', 
                            url: 'https://www.successionresource.com/acquireedge/'
                        }],
                        url: 'https://www.successionresource.com/grow/',
                        service: 'Grow'
                    },

                    {   title: 'Lending Resources', 
                        desc: 'Matching Registered Investment Advisors (RIAs), IBD advisors, independent and captive insurance agents, and tax practices with the right lending solution for an optimized outcome', 
                        modules: [{ 
                            name: 'LendingWell', 
                            icon: 'lending-resources', 
                            color: 'lend', 
                            url: 'https://www.lending-well.com'
                        }],
                        url: 'https://www.lending-well.com',
                        service: 'Lend'
                    },
                    
                    {   title: 'Selling & Succession', 
                        desc: 'SRG’s Selling & Succession services are designed to take the hassle out of exiting the advisory practice, allowing you to focus on your clients while we work to find you the ideal succession candidate.', 
                        modules: [{ 
                            name: 'Seller Advocacy', 
                            icon: 'seller-advocacy', 
                            color: 'exit', 
                            url: 'https://www.successionresource.com/seller-advocacy/'
                        },{ 
                            name: 'Succession Blueprint', 
                            icon: 'succession', 
                            color: 'exit', 
                            url: 'https://www.successionresource.com/succession-planning/'
                        },{ 
                            name: 'SecondLook&trade;', 
                            icon: 'second-look', 
                            color: 'exit', 
                            url: 'https://www.successionresource.com/secondlook/'
                        }],
                        url: 'https://www.successionresource.com/succession/',
                        service: 'Exit'
                    },
                    
                    // {   title: '', 
                    //     desc: 'More services coming soon',
                    //     modules: [],
                    //     url: '' 
                    // },
                ],
            }
        },
        
        mounted () {
            //this.getModules()
        },

        methods: {
            getModules: function () {
                axios.get(`${appUrls.api}/api/modules/${Cookie.get('id')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    //console.log(res.data)
                    if (res.data.outcome) {
                        this.current_modules = res.data.modules.filter(row => {
                            return Object.keys(row.projects).length
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },


            getFlex (value) {
                return is_Even(value) || value == 0 ? true : false;
            },
        }
    }
</script>


<style scoped>
.sansation_chip {
    font-family: 'Sansation';
    font-size: 1.3rem;
}
.thin_font {
    font-weight: 200;
    font-size: .9rem;
    color: #5f6062;
}
.icon-color {
    color: #5f6062;
}
.icon-size {
    width: 6rem;
}
.icon-center {
    margin: 0 auto;
}
/* clip-path version */
.cr {
  width: 150px;
  padding: 9px;
  position: absolute;
  text-align: center;
  color: #FFFFFF;
  /* z-index: 1; */
  overflow:hidden;
  clip-path: polygon(
      72% 0%, 
      100% 100%, 
      0% 100%, 
      28% 0%
  )
}

.cr-sticky {
  position: fixed;
}

/* Positions */
.cr-top    { top: 17px; }
.cr-bottom { bottom: 17px; }
.cr-left   { left: -37x; }
.cr-right  { right: -37px; }

/* Rotations */
.cr-top.cr-left,
.cr-bottom.cr-right {
  transform: rotate(-45deg);
}

.cr-top.cr-right,
.cr-bottom.cr-left {
  transform: rotate(45deg);
}

/* Colors */
.cr-Value   { background-color: #97c131; }
.cr-Improve { background-color: #f1563f; }
.cr-Protect { background-color: #323038; }
.cr-Grow    { background-color: #5f6062; }
.cr-Exit    { background-color: #0096a6; }
.cr-Lend    { background-color: #194253; }



/* NON clip-path version */
.ribbon {
	height: 0;
    width: 160px;
    position: absolute;
    text-align: center;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
}
.ribbon-text {
	color: #FFF;
    font-size: 1em!important;
    letter-spacing: .05em;
    padding: .5em 0;
}

/* Positions */
.ribbon-top    { top: 22px; }
.ribbon-bottom { bottom: 22px; }
.ribbon-left   { left: -41x; }
.ribbon-right  { right: -38px; }

/* Colors */
.ribbon-Value   { border-bottom: 40px solid #97c131; }
.ribbon-Improve { border-bottom: 40px solid #f1563f; }
.ribbon-Protect { border-bottom: 40px solid #323038; }
.ribbon-Grow    { border-bottom: 40px solid #5f6062; }
.ribbon-Exit    { border-bottom: 40px solid #0096a6; }
.ribbon-Lend    { border-bottom: 40px solid #194253; }

</style>



// WEBPACK FOOTER //
// src/components/ServiceCards.vue